import { ReactNode, RefObject } from 'react';
import { ChakraProvider } from '@chakra-ui/react';

import '@fontsource/figtree/400.css';
import '@fontsource/figtree/600.css';
import '@fontsource/figtree/700.css';
import '@fontsource/source-code-pro/400.css';

import { ResponsiveProvider } from '../../hooks/useResponsive';
import theme from '../../theme';

type ProviderProps = {
  children: ReactNode;
  toastOptions?: {
    offsetTop?: string;
    offsetRight?: string;
    portalRef: RefObject<HTMLElement>;
  };
};

const Provider = ({ children, toastOptions }: ProviderProps) => {
  return (
    <ChakraProvider
      theme={theme}
      toastOptions={{
        defaultOptions: {
          containerStyle: {
            marginRight: toastOptions?.offsetRight,
            transform: toastOptions?.offsetTop && `translateY(${toastOptions.offsetTop})`,
          },
        },
        portalProps: {
          containerRef: toastOptions?.portalRef,
        },
      }}
    >
      <ResponsiveProvider>{children}</ResponsiveProvider>
    </ChakraProvider>
  );
};

export default Provider;
